import "packages/frontend/core/src/desktop/dialogs/setting/workspace-setting/billing/styles.css.ts.vanilla.css!=!../../../../../../../../../node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"packages/frontend/core/src/desktop/dialogs/setting/workspace-setting/billing/styles.css.ts.vanilla.css\",\"source\":\"#H4sIAAAAAAAAA91YzZKbOBC+z1PoslXjqsgFGHsmym1fII+QklHbKAFJkWQbZ2vffQsBA8LY/Mwkhz25jFD/fN39dTfrb5/lz42+BuifJ4Ryqo9cYCsVQVGsii9P/z6t6zdC9wbjRmX0StAhg+LLE3K/mHENieVSEJTI7JSL8oRm/Cgwt5AbghIQFnT5+EgHhEdO+IUzmxIUBsFf3cONO0xkJjVBZ6qfMTZWA80zygU+R9hCYbGBRApG9XXlzJLCYsN/wcANd1aYVVdHPNe7QTe2c6XkXOAU+DG1BL1EqniA2/eTsfxwxYkUFoRtj1r1u2H1NzeNogngPdgLgDNDUca4OBIU1jbspWagCQpVgYzMOBvEPaNX0JgLwxn87W7g6uKqlYE1ZfxkCHr1oXpxtpYmEhSiAAXdw9fqcCyGKd61wb7UMO4CT9TnaaL21ICXEHTaPZdGPQu2pQXjCQu5SqnhlYDkpE35tpK8H9X9TWn2oEyGw/6o/sKdL4JN89bkd/Ae91ZpnjfFmXEBb2kfRb4pMOyNMzuusvOBrv3JWik62jqC14oai9kJxvikFgJaS+2JOLwzKVpJR4/war8aSMIeraSLyKmKcae4X1XhlxmflTh3CehOTn3vurjZ+S42/4dI4oPohyY/jlqeBCPIaiqMohqEndQcUry9n+j9Sv0QBKeXTwdgksozaCKkfSaMG7rPgK0c6l3n70PXvoWdpK9n0BntK2kkO8FS0YTbK0HBOu6iIaTFNMvkBVj39o+pRB7fxbtskXUSxXV6OEQcxkNdMHM6h96ZznBzho1Wc/4ezTVpjGm2oC3vKxaLCKLPD37zv6nJuSk1cyBzyLcuyaWzzJ3aWxZR9cFWvLdz1rGqxgCfQt2j5YTZ+vzzz2axP9r0Op92tngZigIUBeVP5f3srtgbN0yfocJtJdgfUuoO7cUvnhu/Vqu90RoPaY1G550HuXuamLsOMBCs3WoCjxjqdTDwcTv70o+aVwI0Z9hCrjJqAVfYG1KSeE6L5zB6VcWnsndEB71qngafUHiomnYVojK8DRlNzTgPuLA3IV9mb5Dt3WLS3W6Rlq30kMkLvujSHSqulxQ0dIVeb/ddfxncDHPx7vfMR5P4vOviAs5ytd00k7nr+a8xvHZ1/WiopZYEk9Ds/4bhbjmGYfAxa0RDD7//G0F455vTzPbrHDSWausJjxbB0f8qtpk64Q5sFC+jDeTBOhvGs5bRZeQXbocK763oBjlq058X8QPdI1NjQ6UEpZyxMrYd26rPXW+cXxv3Hmtu4EbV6sirVHAwoGC9MQioKQn9P61QcT8/FQAA\"}!../../../../../../../../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"
export var billingFrequency = '_9oq3ry9';
export var billingHistorySkeleton = '_9oq3ry5';
export var cancelPlanButton = '_9oq3ryb';
export var cancellationForm = '_9oq3ryv';
export var cancellationLabel = '_9oq3ryw';
export var cancellationSelect = '_9oq3ryy';
export var cancellationTextarea = '_9oq3ryz';
export var cancellationValue = '_9oq3ryx';
export var cardLabel = '_9oq3ryf';
export var cardLabelContainer = '_9oq3rye';
export var cardLabelIcon = '_9oq3ryg';
export var cardName = '_9oq3ryd';
export var cardNameLabelRow = '_9oq3ryc';
export var currentPlan = '_9oq3ry7';
export var currentPlanName = '_9oq3rya';
export var downgradeCaption = '_9oq3ryt';
export var downgradeContent = '_9oq3rys';
export var downgradeContentWrapper = '_9oq3ryr';
export var downgradeFooter = '_9oq3ryu';
export var history = '_9oq3ry1';
export var historyContent = '_9oq3ry2';
export var noInvoice = '_9oq3ry3';
export var paymentMethod = '_9oq3ry0';
export var planCard = '_9oq3ry6';
export var planPrice = '_9oq3ry8';
export var seatInfoText = '_9oq3rym';
export var seatManagerContent = '_9oq3ryh';
export var seatPriceBreakdown = '_9oq3ryl';
export var seatQuotaRow = '_9oq3ryo';
export var seatQuotaRowTotal = '_9oq3ryp';
export var seatQuotaSummary = '_9oq3ryn';
export var seatQuotaUsage = '_9oq3ryq';
export var seatStepper = '_9oq3ryi';
export var seatStepperButton = '_9oq3ryj';
export var seatStepperValue = '_9oq3ryk';
export var subscriptionSettingSkeleton = '_9oq3ry4';
export var trialCard = '_9oq3ry10';
export var trialCardDaysLeft = '_9oq3ry13';
export var trialCardExpiry = '_9oq3ry14';
export var trialCardHeader = '_9oq3ry11';
export var trialCardInfo = '_9oq3ry12';
export var trialProgressBarFill = '_9oq3ry16';
export var trialProgressBarTrack = '_9oq3ry15';